import Zaire from "@/../../public/images/Zaire-Calzoni.jpg";
import React, { useEffect, useRef, useState } from "react";
import Toast from "react-bootstrap/Toast";
import { GoArrowRight } from "react-icons/go";
import moment from "moment";
import { useCustomNavigate } from "../../../hooks/useCustomNavigate";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { AppRoute } from "../../../router/routerConstants";
import { readAllNotification } from "../../../service/apis/auth.api";
import { showError } from "../../../utils/Common";
import { setNotifications } from "../../../store/notification.store";
import { Link } from "react-router-dom";

const NotificationScreen = ({ notifications, show, setShow, asPage }: any) => {
  // const [isLoading, setIsLoading] = useState(false);
  const [visibleNotifications, setVisibleNotifications] = useState([]);

  const [NavigateTo] = useCustomNavigate();
  const { user } = useSelector((state: RootState) => state.authSlice);
  const toastRef = useRef<HTMLDivElement>(null);

  const dispatch = useDispatch();
  useEffect(() => {
    if (asPage) {
      setVisibleNotifications(notifications);
    } else {
      setVisibleNotifications(notifications.slice(0, 3));
    }
  }, [notifications, asPage]);

  useEffect(() => {
    if (show) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const handleOutsideClick = (event: MouseEvent) => {
    if (toastRef.current && !toastRef.current.contains(event.target as Node)) {
      setShow(false);
    }
  };

  const clickNavigate = () => {
    if (user && user?.role === "jobseeker") {
      NavigateTo(AppRoute.JOBSEEKER_NOTIFICATIONS);
    } else if (user && user?.role === "localagents") {
      NavigateTo(AppRoute.AGENT_NOTIFICATIONS);
    } else if (user && user?.role === "employer") {
      NavigateTo(AppRoute.EMPLOYER_NOTIFICATIONS);
    }
  };

  const handleMarkAllRead = async () => {
    try {
      const response = await readAllNotification();
      // console.log("response", response);
      if (response) {
        dispatch(setNotifications([]));
      }
    } catch (error: any) {
      showError(error?.message);
    } finally {
      // setIsLoading(false);
    }
  };


  return (
    <>
      {asPage ? (
        <div
          className={
            asPage ? "notification-list-page" : "notification-dropdown"
          }
        >
          <div className="allNotifications-holder mb-5">
            {notifications && notifications.length > 0 ? (
              <>
                <h4 className="mb-0">All Notifications</h4>
                <button
                  className="mark-all-read-btn btn"
                  onClick={handleMarkAllRead}
                >
                  Mark All as Read
                </button>
              </>
            ) : (
              <div className="no-notification">
                <h4>No new notifications</h4>
              </div>
            )}
          </div>

          <ul className="notifications-list">
            {visibleNotifications &&
              visibleNotifications?.map((notification: any, index: number) => (
                <li key={index}>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  {user?.role === "jobseeker" ? (
                    notification?.type === "chat" ? (
                      <Link to={`/jobseeker/message/${notification?.redirect}`}>
                        <div className="notificationcard">
                          <div className="proimg">
                            <img src={Zaire} alt="profile" />
                          </div>
                          <h4 className="topmenu-truncate-multiline">
                            <strong>{notification.message}{" "}</strong>
                            <span>
                              {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                            </span>
                          </h4>
                        </div>
                      </Link>) : notification.type === "applicant" ? (
                        <Link to="/jobseeker/applied-job">
                          <div className="notificationcard">
                            <div className="proimg">
                              <img src={Zaire} alt="profile" />
                            </div>
                            <h4 className="topmenu-truncate-multiline">
                              <strong>{notification.message}{" "}</strong>
                              <span>
                                {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                              </span>
                            </h4>
                          </div>
                        </Link>) : (
                      <div className="notificationcard">
                        <div className="proimg">
                          <img src={Zaire} alt="profile" />
                        </div>
                        <h4 className="topmenu-truncate-multiline">
                          <strong>{notification.message}{" "}</strong>
                          <span>
                            {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                          </span>
                        </h4>
                      </div>)
                  ) : user?.role === "employer" ? (
                    notification.type === "job" ? (
                      <Link to="/employer/manage-jobs">
                        <div className="notificationcard">
                          <div className="proimg">
                            <img src={Zaire} alt="profile" />
                          </div>
                          <h4 className="truncate-multiline">
                            {notification.message}{" "}
                            <span>
                              {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                            </span>
                          </h4>
                        </div>
                      </Link>
                    ) : notification.type === "applicant" ? (
                      <Link
                        to="/employer/applicants"
                        state={{ jobId: notification?.redirect }}
                      >
                        <div className="notificationcard">
                          <div className="proimg">
                            <img src={Zaire} alt="profile" />
                          </div>
                          <h4 className="topmenu-truncate-multiline">
                            <strong>{notification?.message}{" "}</strong>
                            <span>
                              {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                            </span>
                          </h4>
                        </div>
                      </Link>
                    ) : notification.type === "chat" ? (
                      <Link
                        to={`/employer/message/${notification?.redirect}`}
                      // state={{ jobId: notification?.redirect }}
                      >
                        <div className="notificationcard">
                          <div className="proimg">
                            <img src={Zaire} alt="profile" />
                          </div>
                          <h4 className="topmenu-truncate-multiline">
                            <strong>{notification?.message}{" "}</strong>
                            <span>
                              {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                            </span>
                          </h4>
                        </div>
                      </Link>
                    ) : (
                      <div className="notificationcard">
                        <div className="proimg">
                          <img src={Zaire} alt="profile" />
                        </div>
                        <h4 className="topmenu-truncate-multiline">
                          <strong>{notification.message}{" "}</strong>
                          <span>
                            {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                          </span>
                        </h4>
                      </div>
                    )
                  ) : user?.role === "localagents" ? (
                    notification.type === "chat" ?
                      (<Link
                        to={`/agent-flow/message/${notification?.redirect}`}>
                        <div className="notificationcard">
                          <div className="proimg">
                            <img src={Zaire} alt="profile" />
                          </div>
                          <h4 className="topmenu-truncate-multiline">
                            <strong>{notification.message}{" "}</strong>
                            <span>
                              {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                            </span>
                          </h4>
                        </div></Link>
                      ) : (notification.type === "applicant" ?
                        <Link
                          to={{ pathname: "/agent-flow/applications", }} state={{ jobId: notification.redirect }} >
                          <div className="notificationcard">
                            <div className="proimg">
                              <img src={Zaire} alt="profile" />
                            </div>
                            <h4 className="topmenu-truncate-multiline">
                              <strong>{notification.message}{" "}</strong>
                              <span>
                                {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                              </span>
                            </h4>
                          </div>
                        </Link> : <div className="notificationcard">
                          <div className="proimg">
                            <img src={Zaire} alt="profile" />
                          </div>
                          <h4 className="topmenu-truncate-multiline">
                            <strong>{notification.message}{" "}</strong>
                            <span>
                              {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                            </span>
                          </h4>
                        </div>)
                  ) : (
                    <div className="notificationcard">
                      <div className="proimg">
                        <img src={Zaire} alt="profile" />
                      </div>
                      <h4 className="topmenu-truncate-multiline">
                        <strong>{notification.message}{" "}</strong>
                        <span>
                          {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                        </span>
                      </h4>
                    </div>
                  )}
                </li>
              ))}
          </ul>
        </div>
      ) : (
        <Toast
          onClose={() => setShow(false)}
          show={show}
          delay={3000}
          autohide
          ref={toastRef}
        >
          <Toast.Body>
            <ul>
              {notifications && notifications.length > 0 ? (
                visibleNotifications &&
                visibleNotifications?.map(
                  (notification: any, index: number) => (
                    <li key={index}>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      {user?.role === "jobseeker" ? (
                        notification?.type === "chat" ?
                          (<Link to={`/jobseeker/message/${notification?.redirect}`}>
                            <div className="notificationcard">
                              <div className="proimg">
                                <img src={Zaire} alt="profile" />
                              </div>
                              <h4 className="topmenu-truncate-multiline">
                                <strong>{notification.message}{" "}</strong>
                                <span>
                                  {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                                </span>
                              </h4>
                            </div>
                          </Link>)
                          : notification.type === "applicant" ?
                            (<Link to="/jobseeker/applied-job">
                              <div className="notificationcard">
                                <div className="proimg">
                                  <img src={Zaire} alt="profile" />
                                </div>
                                <h4 className="topmenu-truncate-multiline">
                                  <strong>{notification.message}{" "}</strong>
                                  <span>
                                    {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                                  </span>
                                </h4>
                              </div>
                            </Link>) : (
                              <div className="notificationcard">
                                <div className="proimg">
                                  <img src={Zaire} alt="profile" />
                                </div>
                                <h4 className="topmenu-truncate-multiline">
                                  <strong>{notification.message}{" "}</strong>
                                  <span>
                                    {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                                  </span>
                                </h4>
                              </div>)
                      ) : user?.role === "employer" ? (
                        notification.type === "job" ? (
                          <Link to="/employer/manage-jobs">
                            <div className="notificationcard">
                              <div className="proimg">
                                <img src={Zaire} alt="profile" />
                              </div>
                              <h4 className="topmenu-truncate-multiline">
                                <strong>{notification.message}{" "}</strong>
                                <span>
                                  {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                                </span>
                              </h4>
                            </div>
                          </Link>
                        ) : notification.type === "applicant" ? (

                          <Link
                            to="/employer/applicants"
                            state={{ jobId: notification?.redirect }}
                          >
                            <div className="notificationcard">
                              <div className="proimg">
                                <img src={Zaire} alt="profile" />
                              </div>
                              <h4 className="topmenu-truncate-multiline">
                                <strong>{notification?.message}{" "}</strong>
                                <span>
                                  {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                                </span>
                              </h4>
                            </div>
                          </Link>
                        ) : notification.type === "chat" ? (
                          <Link
                            to={`/employer/message/${notification?.redirect}`}
                          // state={{ jobId: notification?.redirect }}
                          >
                            <div className="notificationcard">
                              <div className="proimg">
                                <img src={Zaire} alt="profile" />
                              </div>
                              <h4 className="topmenu-truncate-multiline">
                                <strong>{notification?.message}{" "}</strong>
                                <span>
                                  {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                                </span>
                              </h4>
                            </div>
                          </Link>
                        ) : (
                          <div className="notificationcard">
                            <div className="proimg">
                              <img src={Zaire} alt="profile" />
                            </div>
                            <h4 className="topmenu-truncate-multiline">
                              <strong>{notification.message}{" "}</strong>
                              <span>
                                {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                              </span>
                            </h4>
                          </div>
                        )
                      ) : user?.role === "localagents" ? (
                        notification.type === "chat" ?
                          (<Link
                            to={`/agent-flow/message/${notification?.redirect}`}>
                            <div className="notificationcard">
                              <div className="proimg">
                                <img src={Zaire} alt="profile" />
                              </div>
                              <h4 className="topmenu-truncate-multiline">
                                <strong>{notification.message}{" "}</strong>
                                <span>
                                  {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                                </span>
                              </h4>
                            </div>
                          </Link>
                          ) : (notification.type === "applicant" ?
                            <Link
                              to={{ pathname: "/agent-flow/applications", }} state={{ jobId: notification.redirect }} >
                              <div className="notificationcard">
                                <div className="proimg">
                                  <img src={Zaire} alt="profile" />
                                </div>
                                <h4 className="topmenu-truncate-multiline">
                                  <strong>{notification.message}{" "}</strong>
                                  <span>
                                    {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                                  </span>
                                </h4>
                              </div>
                            </Link> : <div className="notificationcard">
                              <div className="proimg">
                                <img src={Zaire} alt="profile" />
                              </div>
                              <h4 className="topmenu-truncate-multiline">
                                <strong>{notification.message}{" "}</strong>
                                <span>
                                  {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                                </span>
                              </h4>
                            </div>)
                      ) : <div className="notificationcard">
                        <div className="proimg">
                          <img src={Zaire} alt="profile" />
                        </div>
                        <h4 className="topmenu-truncate-multiline">
                          <strong>{notification.message}{" "}</strong>
                          <span>
                            {moment(notification?.createdAt).format("DD MMMM YYYY - hh:mm A")}
                          </span>
                        </h4>
                      </div>}
                    </li>
                  )
                )
              ) : (
                <p>No new notifications</p>
              )}
              {notifications && notifications.length > 0 && (
                <li>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a onClick={clickNavigate} style={{ cursor: "pointer" }}>
                    See All Notification <GoArrowRight />
                  </a>
                </li>
              )}
            </ul>
          </Toast.Body>
        </Toast>
      )}
    </>
  );
};

export default NotificationScreen;
